import { eq } from '@tanstack/db'
import { useLiveQuery } from '@tanstack/react-db'
import { useStore } from '@/lib/pocketbase'
import type { Addresses, Customers, Jobs, Tags } from '@/types/pbSchema'

export type JobRecordWithExpand = Jobs & {
    expand?: {
        address?: Addresses
        customer?: Customers
        tags?: Tags[]
    }
}

export function useJobRecord(jobSlug: string | undefined) {
    const [jobStore, locStore, custStore] = useStore('jobs', 'locations', 'customers')

    const { isLoading, data = [] } = useLiveQuery(
        q =>
            jobSlug
                ? q
                      .from({ job: jobStore })
                      .where(({ job }) => eq(job.identifier, jobSlug))
                      .leftJoin({ locations: locStore }, ({ locations, job }) =>
                          eq(job.id, locations.job)
                      )
                      .leftJoin({ customer: custStore }, ({ customer, job }) =>
                          eq(job.customer, customer.id)
                      )
                : undefined,
        [jobSlug]
    )

    if (!data.length) {
        return {
            isLoading,
            job: undefined,
            locations: [],
            customer: undefined,
        }
    }

    const job = data[0].job
    const locations = data
        .map(item => item.locations)
        .filter((loc): loc is NonNullable<typeof loc> => Boolean(loc))
    const customer = data[0].customer

    return {
        isLoading,
        job,
        locations,
        customer,
    }
}
